export default {
  noData: 'Nessun altro dato disponibile',
  delConfirmTips: 'Sei sicuro di voler eliminare i dati selezionati?',
  delSuccess: 'Eliminato con successo',
  tips: 'Suggerimenti',
  add: 'Aggiungi',
  edit: 'Modifica',
  del: 'Elimina',
  editSuccess: 'Modificato con successo',
  activeAccount: 'Attiva account',
  mailActiveSuccess: 'Attivazione account riuscita',
  back: 'Indietro',
  goLogin: 'Vai al login',
  email: 'E-mail',
  emailSendSuccess: 'E-mail inviata con successo',
  paySuccess: 'Pagamento riuscito',
  action: 'Azione',
  logoutSuccess: 'Disconnessione riuscita',
  plsUpload: 'Si prega di caricare',
  upload: 'Carica',
  file: 'File',
  uploadFail: 'Caricamento fallito',
  uploadSuccess: 'Caricamento riuscito',
  pay: 'Paga',
  day: 'Giorno',
  servePrice: 'Costo del servizio',
  skillServePrice: 'Costo del servizio tecnico',
  unitMonth: 'Mese',
  num: 'Quantità',
  photo: 'Foto',
  product: 'Prodotto',
  sizeHaveUnit: 'Taglia (cm)',
  weightHaveUnit: 'Peso (g)',
  fee: 'Costo',
  free: 'Gratuito',
  submitTime: 'Ora di invio',
  weight: 'Peso',
  cancelReason: 'Motivo di annullamento',
  submitPackage: 'Invia pacco',
  submitSuccess: 'Invio riuscito',
  price: 'Prezzo',
  status: 'Stato',
  noProduct: 'Nessun prodotto',
  backEdit: 'Torna alla modifica',
  errorHint: 'Errore di interfaccia, riprova',
  reload: 'Ricarica',
  reloadPageTips:
    'Hai cambiato account. Ricarica la pagina per ottenere le informazioni aggiornate.',
  cancel: 'Annulla',
  noMsg: 'Nessuna informazione',
  totalAmount: 'Importo totale',
  see: 'Vedi',
  confirm: 'Conferma',
  send: 'Invia',
  nowNoInfo: 'Nessuna informazione al momento',
  genderEnum: {
    0: 'Uomo',
    1: 'Donna',
  },
  goEmailActiveTips: 'Si prega di controllare la tua e-mail per attivare il tuo account!',
  holder: {
    inputRemark: 'Si prega di inserire delle note',
    inputExplainCancelReason: "Si prega di spiegare il motivo dell'annullamento",
    inputAddAddress: "Si prega di aggiungere l'indirizzo di spedizione",
    inputMsg: 'Si prega di inserire un messaggio',
  },
  acceptMsg:
    "Questo sito web memorizza cookie sul tuo computer per offrirti un'esperienza migliore. Consulta la nostra politica sulla privacy per maggiori informazioni.",
  accept: 'Accetta',
  refuse: 'Rifiuta',
  notice: 'Avviso',
  noticeMsg: 'Nuova linea logistica, riduzione di prezzo del 10%',
  english: 'Inglese',
  spanish: 'Spagnolo',
  french: 'Francese',
  chinese: 'Cinese',
  copySuccess: 'Copia riuscita',
  copyError: 'Copia fallita',
  noAgainShow: 'Non mostrare più',
  download: 'Scarica',
  downloadSuccess: 'Download riuscito',
  uploadImgTips: 'Si prega di caricare file JPG/PNG/WEBP/JPEG',
  noCheckAboutAgree: 'Non selezionato: Accetto i termini di utilizzo',
  country: 'Paese',
  collectSuccess: 'Aggiunto ai preferiti con successo!',
  cancelCollectSuccess: 'Rimozione dai preferiti riuscita!',
  formatError: 'Errore di formato, ad esempio, {formatStr}',
  volume: 'Volume (cm³)',
  notRequired: 'Non richiesto',
  productSaleCount: 'Vendite',
  searchPlaceholder: 'Si prega di inserire il contenuto di ricerca',
  THEME_MODE: 'Modalità tema',
  FOLLOW_SYSTEM: 'Segui il sistema',
  DAY_MODE: 'Modalità giorno',
  NIGHT_MODE: 'Modalità notte',
}
